export default __webpack_public_path__ + "static/media/fr.fdd508df.svg";